import './Layout.less';
import React, {useState, useContext, useEffect} from 'react';
import TopNav from "./top-nav/TopNav";
import SideNav from "./side-nav/SideNav";
import PageContent from "./page-content/PageContent";
import {useHistory} from 'react-router-dom';
import NavigationContext from "../contexts/navigation/NavigationContext";
import dashboardNavItems from "./config/dashboardNavItems";
import getLayoutType from "./config/getLayoutType";
import MediaQueryDisplay from '../components/media-query-display/MediaQueryDisplay';
import screenSizeQueries from '../styles/screenSizeQueries';
import Button from '../../bootstrap/components/button/Button';
import Popup from '../../bootstrap/components/popup/Popup';
import __ from '../i18n';
import Icon from '../../bootstrap/components/icon/Icon';

export const LAYOUT_DEFAULT = 'DEFAULT';
export const LAYOUT_DASHBOARD = 'DASHBOARD';

export default function Layout({children}) {

    const history = useHistory();

    const navigationContext = useContext(NavigationContext);

    const [layoutType, setLayoutType] = useState(getLayoutType(history.location.pathname));

    useEffect(() => {
        navigationContext.setActiveKey(history.location.pathname);
        setLayoutType(getLayoutType(history.location.pathname));

        history.listen((location) => {
            navigationContext.setActiveKey(location.pathname);
            setLayoutType(getLayoutType(location.pathname));
        });
    }, []);

    if (layoutType === LAYOUT_DASHBOARD) {
        return <div className="dashboard-layout">
            <TopNav/>
            <div className="layout-body">
                <MediaQueryDisplay query={screenSizeQueries.desktop}>
                    <SideNav leveledItems={dashboardNavItems}/>
                </MediaQueryDisplay>
                <MediaQueryDisplay excludes query={screenSizeQueries.desktop}>
                    <NavFloatButton/>
                </MediaQueryDisplay>
                <PageContent content={children} layoutType={layoutType}/>
            </div>
        </div>;
    }

    return <div className="default-layout">
        <TopNav/>
        <div className="layout-body">
            <PageContent content={children} layoutType={layoutType}/>
        </div>
    </div>;
}

function NavFloatButton() {
    const [showsNav, setShowsNav] = useState(false);

    return (
        <>
            <button
                className="nav-float-button"
                title={__('Navigation')}
                onClick={() => setShowsNav(true)}
            >
                <Icon name="grid"/>
            </button>
            {
                showsNav &&
                <Popup
                    title={__('Navigation')}
                    close={() => setShowsNav(false)}
                >
                    <SideNav
                        leveledItems={dashboardNavItems}
                        float={true}
                    />
                </Popup>
            }
        </>
    );
}
